<template>
  <div class="address-display">
    <p v-if="address.name">
      <strong>Name:</strong>
      <span>{{ address.name }}</span>
    </p>
    <p v-if="address.company">
      <strong>Company:</strong>
      <span>{{ address.company }}</span>
    </p>

    <!-- Costa Rica Address Format -->
    <template v-if="isCostaRica">
      <p v-if="address.street1">
        <strong>Street:</strong>
        <span>{{ address.street1 }}</span>
      </p>
      <p v-if="address.street2">
        <strong>Street 2:</strong>
        <span>{{ address.street2 }}</span>
      </p>
      <p v-if="address.street3">
        <strong>Street 3:</strong>
        <span>{{ address.street3 }}</span>
      </p>
      <p>
        <strong>Provincia:</strong>
        <span>{{ address.provincia || "-" }}</span>
      </p>
      <p>
        <strong>Canton:</strong>
        <span>{{ address.canton || "-" }}</span>
      </p>
      <p>
        <strong>Distrito:</strong>
        <span>{{ address.distrito || "-" }}</span>
      </p>
      <p>
        <strong>Barrio:</strong>
        <span>{{ address.barrio || "-" }}</span>
      </p>
      <p v-if="address.postalCode">
        <strong>Postal Code:</strong>
        <span>{{ address.postalCode }}</span>
      </p>
      <p>
        <strong>Country:</strong>
        <span>{{ address.country }}</span>
      </p>
    </template>

    <!-- Standard USA/International Address Format -->
    <template v-else>
      <p v-if="address.street1">
        <strong>Street 1:</strong>
        <span>{{ address.street1 }}</span>
      </p>
      <p v-if="address.street2">
        <strong>Street 2:</strong>
        <span>{{ address.street2 }}</span>
      </p>
      <p v-if="address.street3">
        <strong>Street 3:</strong>
        <span>{{ address.street3 }}</span>
      </p>
      <p>
        <strong>City:</strong>
        <span>{{ address.city || "-" }}</span>
      </p>
      <p>
        <strong>State:</strong>
        <span>{{ address.state || "-" }}</span>
      </p>
      <p>
        <strong>Postal Code:</strong>
        <span>{{ address.postalCode || "-" }}</span>
      </p>
      <p>
        <strong>Country:</strong>
        <span>{{ address.country }}</span>
      </p>
    </template>

    <p>
      <strong>Phone:</strong>
      <span>{{ phone }}</span>
    </p>

    <p v-if="showResidential">
      <ResidentialBadge
        :residential="address.residential"
        :verified="address.addressVerified"
      />
    </p>
    <p v-if="showStatus && address.hasOwnProperty('disabled')">
      <strong>{{ statusLabel }}:</strong>
      <span>{{ address.disabled === 1 ? disabledLabel : enabledLabel }}</span>
    </p>
  </div>
</template>

<script>
import { formatPhone } from "@/utils/phone";
import ResidentialBadge from "@/components/shared/ResidentialBadge.vue";

export default {
  name: "InfoautoAddressDisplay",
  components: {
    ResidentialBadge
  },
  props: {
    address: {
      type: Object,
      required: true
    },
    showResidential: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    statusLabel: {
      type: String,
      default: "Status"
    },
    enabledLabel: {
      type: String,
      default: "Enabled"
    },
    disabledLabel: {
      type: String,
      default: "Disabled"
    }
  },
  computed: {
    phone() {
      return formatPhone(this.address.phoneAreaCode, this.address.phone);
    },
    isCostaRica() {
      const activeStore = this.$store.getters["general/getActiveStore"];
      return activeStore?.code === "nkr_costa_rica";
    }
  }
};
</script>

<style scoped>
/* Etiqueta | valor en dos columnas. Antes cortaba con "..." las calles largas */
.address-display p {
  display: grid;
  grid-template-columns: minmax(90px, 32%) minmax(0, 1fr);
  column-gap: 0.75rem;
  margin: 0;
  padding: 0.3rem 0;
  border-bottom: 1px solid #f3f4f6;
  font-size: 16px;
  color: #111827;
  overflow-wrap: anywhere;
}

/* El valor va en su <span>: como texto suelto era un item anonimo del grid y
   iOS Safari, al convertir telefonos/numeros/direcciones en enlaces, lo
   partia en varios items que caian en la columna de la etiqueta */
.address-display p > span {
  min-width: 0;
}

.address-display p:last-child {
  border-bottom: none;
}

.address-display p strong {
  font-weight: 500;
  color: #6b7280;
}
</style>
